import { gtagEnabled } from './index'
import { formatMedusaPrice } from '../formatMedusaPrice'
import { PricedVariant } from '@medusajs/medusa/dist/types/pricing'
import { ProductVariant } from '@medusajs/medusa'

export const trackAddToCart = (variant: PricedVariant | ProductVariant, quantity: number, price: number) => {
    if (gtagEnabled()) {
        gtag('event', 'add_to_cart', {
            currency: 'EUR',
            value: formatMedusaPrice(variant.prices[0].amount),
            items: [
                {
                    item_name: variant.title,
                    item_id: variant.id,
                    quantity: quantity,
                    price: price,
                },
            ],
        })
    }
}
